import React from 'react'
import * as moment from 'moment'
import { useSelector, useDispatch } from 'react-redux'
import { ChangeIconButton, DeleteIconButton } from '../../../library/button'

const Index = ({singleFile, index, arr }) => {

    const deletions = useSelector(state => state.library.deletionArray)

    const activeCompany = useSelector(state => state.activeCompany && state.activeCompany.activeCompany)

    const determineSettingsHoverButton = () => {
        if(!activeCompany){
            return "Du må velge et selskap før du kan utføre denne handlingen."
        }

        if(activeCompany && !activeCompany.subscription){
            return "Du må ha et aktivt abonnement for å kunne gjøre dette."
        }
    }

    return(
        <tr key={singleFile.key} className={index === (arr.length - 1) && "last"}>
            <td><input key={singleFile.key} fileId={singleFile.key} name="fileId" checked={deletions.includes(singleFile.key) ? true:false} className="select-all-files" type="checkbox" id="select"/></td>
            <td><a href={activeCompany.subscription && singleFile.password ? null:singleFile.downloadLink}>Wordpress nettside</a></td>
            <td>Bowii AS</td>
			<td className="date-row">23:06 15/06/2021</td>
            <td>24 dager</td>
            <td className="progressbar-row"><div className="progress" style={{ display: 25 > 0 ? 'flex': 'none'}}><div className="progress-bar" role="progressbar" style={{width: 25 + '%'}} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">25%</div></div></td>
            <td>10 000kr</td>
            <td><ChangeIconButton data-tip={determineSettingsHoverButton()}/><DeleteIconButton/></td>
        </tr>
    )
}

export default Index

